import script from "./TelegramAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramAbout.vue?vue&type=script&setup=true&lang=js"

import "./TelegramAbout.vue?vue&type=style&index=0&id=1032d1b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1032d1b1"]])

export default __exports__